/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-06-14 13:19:35
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-18 09:48:35
 * @FilePath: \xdjs-manage\ruoyi-ui\src\api\heart\sleep.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'


// 查询睡眠记录列表
export function listSleep(query) {
  return request({
    url: '/heart/sleep/list',
    method: 'get',
    params: query
  })
}

// 查询睡眠记录分页
export function pageSleep(query) {
  return request({
    url: '/heart/sleep/page',
    method: 'get',
    params: query
  })
}
export function healthRecord(query) {
  return request({
    url: '/health/healthRecord/page',
    method: 'get',
    params: query
  })
}
export function electrocardiogram(query) {
  return request({
    url: '/electrocardiogram/electrocardiogram/page',
    method: 'get',
    params: query
  })
}
export function electrocardiogramdetail(query) {
  return request({
    url: '/electrocardiogram/electrocardiogram/detail',
    method: 'get',
    params: query
  })
}
export function infoPhysiology(query) {
  return request({
    url: '/physiology/physiology/info',
    method: 'get',
    params: query
  })
}
export function detailPhysiology(query) {
  return request({
    url: '/physiology/physiology/detail',
    method: 'get',
    params: query
  })
}



// 查询睡眠记录详细
export function getSleep(data) {
  return request({
    url: '/heart/sleep/detail',
    method: 'get',
    params: data
  })
}

// 新增睡眠记录
export function addSleep(data) {
  return request({
    url: '/heart/sleep/add',
    method: 'post',
    data: data
  })
}

// 修改睡眠记录
export function updateSleep(data) {
  return request({
    url: '/heart/sleep/edit',
    method: 'post',
    data: data
  })
}

// 删除睡眠记录
export function delSleep(data) {
  return request({
    url: '/heart/sleep/delete',
    method: 'post',
    data: data
  })
}
